const AboutSection = () => {
  return (
    <div className="grid gap-10 md:grid-cols-[minmax(15rem,0.95fr)_minmax(0,1.7fr)] md:gap-14">
      <aside>
        <div className="overflow-hidden rounded-[0.9rem] border border-[color:var(--wf-border)] bg-[rgba(251,246,238,0.7)] p-3 shadow-[0_10px_28px_rgba(44,32,27,0.08)]">
          <img
            src="/casual.jpeg"
            alt="Adam Martin headshot"
            className="aspect-[4/5] h-full w-full rounded-[0.45rem] object-cover"
          />
        </div>
      </aside>

      <div className="space-y-5 text-[color:var(--wf-ink-soft)]">
        <p className="font-serif text-2xl leading-relaxed text-[color:var(--wf-ink)]">
          I build systems for a living. Mostly software. <br />
          I've been doing it for a while.
        </p>
        <p className="leading-8">
          Sometimes I lead. Usually because things need clarity more than they need control.
        </p>
        <p className="leading-8">
          I sing. I play a little piano and guitar.<br />
          Not professionally. Just... because I can't not.
        </p>
        <p className="leading-8">
        </p>
        <p className="leading-8">
          I have four kids. It's hard. It's rewarding. It's humbling. <br />
          I wouldn't have it any other way.
        </p>
        <p className="leading-8">
          I think a lot about how things work. How people work. <br />
          Or how they don't.
        </p>
        <p className="leading-8">
          This space is my digital workshop. I can't guarantee it'll be tidy, so tread carefully.
        </p>
        <p className="pt-2 font-serif text-xl italic text-[color:var(--wf-plum)]">- Adam</p>
      </div>
    </div>
  );
};

export default AboutSection;
